<div class="main-content">
  <app-header [title]="'HEADER.FINAL_USERS_HOME' | translate"> </app-header>
  <app-banner-carousel></app-banner-carousel>
  <div class="row mt-5">
    <div class="col-12">
      <app-profile mode="full" [subtitle]="'PROFILE.FINAL_USER_SUBTITLE' | translate" />
    </div>
  </div>
  <div class="row mt-5">
    <div class="col-12">
      <app-icam-container [iconName]="'user'" [iconColor]="'black'">
        @if (lastFinalUserSeen$ | async; as lastFinalUserSeen) {
          @if (lastFinalUserSeen) {
            <app-table
              [type]="'last_final_user'"
              [allValues$]="lastFinalUserSeen$"
              [hasChart]="false"
              [useInlineKeywordFilter]="true"
              />
          }
          <div class="mt-5"></div>
        }

        <app-table
          [type]="'final_users'"
          [allValues$]="clients$"
          [filters$]="clientFilters$"
          [hasChart]="false"
          (selectedFilter)="onSelectedFilter($event)"
          [prevPage]="prevPage"
          [currentPage]="currentPage"
          [nextPage]="nextPage"
          (selectedPage)="onChangePage($event)"
          [useInlineKeywordFilter]="true"
          />
      </app-icam-container>
    </div>
  </div>
  <div class="mt-5 pb-3" id="icamRights">
    <span> &copy; {{ getYear() }} ICAM S.P.A - All rights reserved </span>
  </div>
</div>
